module.exports = __webpack_public_path__ + "img/commonShare@2x.5f456273.png";